import React from 'react';
import { Shield } from 'lucide-react';
import CTAButtons from './CTAButtons';

const MainCTA = () => {
  return (
    <section id="home" className="py-24 bg-gradient-to-br from-blue-900 via-blue-800 to-emerald-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzBoMnYyaC0ydi0yem0wLThoMnYyaC0ydi0yem0wLTE2aDJ2MmgtMnYtMnptMCA4aDJ2MmgtMnYtMnptMCAxNmgydjJoLTJ2LTJ6bTAgOGgydjJoLTJ2LTJ6bTAtNDBoMnYyaC0ydi0yem0wIDhoMnYyaC0ydi0yem0wIDE2aDJ2MmgtMnYtMnptMCA4aDJ2MmgtMnYtMnoiLz48L2c+PC9nPjwvc3ZnPg==')]" />
      </div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full">
            <Shield className="w-5 h-5" />
            <span className="text-sm font-semibold">Secure Your Brand</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            Protect Your Brand Identity
          </h2>
          <p className="text-xl text-blue-100 mb-8 leading-relaxed">
            Global Trademark Pro helps with US trademark registration for your business name, logo, or slogan. With our expert trademark filing consultancy services, we help you apply for a trademark online, ensuring swift and secure brand protection across the USA.
          </p>
          <CTAButtons className="justify-center" variant="dark" />
        </div>
      </div>
    </section>
  );
};

export default MainCTA;